import { render, staticRenderFns } from "./DefaultActiveFilter.vue?vue&type=template&id=425d0bc9&"
import script from "./DefaultActiveFilter.vue?vue&type=script&lang=js&"
export * from "./DefaultActiveFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports